import postsLoadMore from "../components/postsLoadMore";
import {hideWrapper} from '../components/hideWrapper';
import autoComplete from "@tarekraafat/autocomplete.js";

export default () => {
    hideWrapper('vacancies');
    postsLoadMore();
    filtrationVacancies();


    const cont = document.querySelector(".filters");

    cont ? hideFilter() : false;

    function hideFilter() {
        const filters = cont.querySelectorAll(".filters-wrapper");

        filters.forEach((filter) => {
            const filterList = filter.querySelector(".filters-list");
            const filterTitle = filter.querySelector(".filters-title");

            const filterTitleHeight = filterTitle.offsetHeight;

            filterTitle.addEventListener("click", () => {
                if (filter.classList.contains("closed")) {
                    filter.style.maxHeight = "100em";
                } else {
                    filter.style.maxHeight = filterTitleHeight + "px";
                }
                filter.classList.toggle("closed");
            });
        });
    }


    const vacanciesList = document.querySelector('.vacancies-list');
    if (vacanciesList) {
        vacanciesList.addEventListener('click', () => {
            const wrappers = vacanciesList.querySelectorAll(".vacancies-item-activeFillter-wrapper");
            wrappers.forEach((wrapper) => {
                const shareBtn = wrapper.querySelector(".openShareModal");
                const modalBlock = wrapper.querySelector(".share-links");
                const closeBtn = wrapper.querySelector(".close-window");

                if (shareBtn == event.target) {
                    modalBlock.classList.toggle("visible");
                }


                if (closeBtn == event.target) {
                    modalBlock.classList.toggle("visible");
                }

            })
        });
    }
    const breakpoint = window.matchMedia("(min-width:769px)");

    if (breakpoint.matches === false) {
        cont ? hideFilterMobile() : false;

        function hideFilterMobile() {

            const filterClick = document.querySelector(".vacancies-filter-wrapper");
            const filterBlock = document.querySelector(".filters");
            const shadow = document.querySelector(".shadow");
            const closeBtn = document.querySelector(".close-window");
            console.log(shadow);
            if (filterBlock.classList.contains("closed")) {
                filterBlock.style.maxHeight = 0;
            }
            filterClick.addEventListener("click", () => {
                if (filterBlock.classList.contains("closed")) {
                    filterBlock.style.maxHeight = "200em";
                    shadow.style.display = "block";
                } else {
                    filterBlock.style.maxHeight = 0;
                    shadow.style.display = "none";

                }
                filterBlock.classList.toggle("closed");
                filterClick.classList.toggle("reverse-arrow");
            });

            closeBtn.addEventListener("click", () => {
                if (filterBlock.classList.contains("closed")) {
                    filterBlock.style.maxHeight = "200em";
                    shadow.style.display = "block";
                } else {
                    filterBlock.style.maxHeight = 0;
                    shadow.style.display = "none";

                }
                filterBlock.classList.toggle("closed");
                filterClick.classList.toggle("reverse-arrow");
            })
        }
    }

    function filtrationVacancies() {
        let filtrationCheckboxes = document.querySelectorAll('[data-filter-category]');
        let filtrationForm = document.getElementById('vacanciesFiltrationForm');
        let searchInput = document.getElementById('jobTitle');
        let citiesSelectorHead = document.getElementById('citiesHead');
        let citiesCheckboxes = document.querySelectorAll('[data-filter-category = location]');
        let regionSelect = document.getElementById('regionSelect');
        let regionSelectHead = document.getElementById('regionSelectHead');
        let regionSelectOptions = regionSelect.querySelectorAll('option');
        let regionSelectOptionsHead = regionSelectHead.querySelectorAll('option');

        function updateFiltrationParameters() {
            let filterCategories = {
                position_type: '',
                region: '',
                location: '',
                discipline: '',
                title: '',
            };

            filtrationCheckboxes.forEach((item) => {
                if (item.checked) {
                    let checkboxDataCat = item.getAttribute('data-filter-category');
                    let checkboxVal = item.value;
                    if (filterCategories[`${checkboxDataCat}`] && filterCategories[`${checkboxDataCat}`] !== '' && checkboxDataCat !== 'location') {
                        filterCategories[`${checkboxDataCat}`] += `, ${checkboxVal}`;
                    } else {
                        filterCategories[`${checkboxDataCat}`] = checkboxVal;
                    }
                }
            });
            if (regionSelect.value && regionSelect.value !== '') {
                filterCategories.region = regionSelect.value;
            }
            if (searchInput.value && searchInput.value !== '') {
                filterCategories.title = searchInput.value;
            }
            for (let key in filterCategories) {
                let currentInput = filtrationForm.querySelector(`[name=${key}]`);
                currentInput.setAttribute('value', filterCategories[`${key}`]);
            }
        }

        function citiesCheckboxesLogic(item) {
            let currentVall = item.value;
            let currentData = item.getAttribute('data-filter-category');
            if (currentData === 'location') {
                let citiesCheckboxes = document.querySelectorAll('[data-filter-category = location]');
                let citiesSelectOptionsHead = document.querySelectorAll('#citiesHead option');
                citiesCheckboxes.forEach((item) => {
                    if (item.value !== currentVall) {
                        item.checked = false;
                    }
                });
                if (item.checked === true) {
                    citiesSelectOptionsHead.forEach((item) => {
                        if (item.value === currentVall) {
                            let nodes = Array.from(item.closest('select').children);
                            citiesSelectorHead.selectedIndex = nodes.indexOf(item);
                        }
                    });
                } else {
                    citiesSelectorHead.selectedIndex = 0;
                }
            }
        }

        function sincRegionSelects(regionOptions, currentVal) {
            regionOptions.forEach((item) => {
                let selectVal = item.value;
                console.log('selectVal - '+selectVal);
                if (selectVal === currentVal) {
                    let nodes = Array.from(item.closest('select').children);
                    item.closest('select').selectedIndex = nodes.indexOf(item);
                }
            });
        }

        function showCities(currentVal, dataAttr) {
            let options = document.querySelectorAll(`[${dataAttr}]`);
            options.forEach((item) => {
                let currentAttr = item.getAttribute(`${dataAttr}`);
                item.classList.remove('show');
                if (currentAttr === currentVal) {
                    item.classList.add('show');
                }
            });
        }

        filtrationCheckboxes.forEach((item) => {
            item.addEventListener('change', function () {
                citiesCheckboxesLogic(item);
                updateFiltrationParameters();
                filtrationForm.submit();
            });
        });

        searchInput.addEventListener('change', function () {
            updateFiltrationParameters();
        });

        regionSelect.addEventListener('change', function (e) {
            let target = e.target;
            let currentVal = target.value;
            citiesSelectorHead.selectedIndex = 0;
            citiesCheckboxes.forEach((item) => {
                    item.checked = false;
            });
            showCities(currentVal, 'data-region');
            showCities(currentVal, 'data-region-head');
            sincRegionSelects(regionSelectOptionsHead, currentVal);
            updateFiltrationParameters();
            if (currentVal !== 'placeholder') {
                citiesSelectorHead.closest('.location-wrapper').classList.remove('noActive');
            } else {
                citiesSelectorHead.closest('.location-wrapper').classList.add('noActive');
            }
        });

        regionSelectHead.addEventListener('change', function (e) {
            let target = e.target;
            let currentVal = target.value;
            citiesSelectorHead.selectedIndex = 0;
            citiesCheckboxes.forEach((item) => {
                item.checked = false;
            });
            showCities(currentVal, 'data-region-head');
            showCities(currentVal, 'data-region');
            sincRegionSelects(regionSelectOptions, currentVal);
            updateFiltrationParameters();
            if (currentVal !== 'placeholder') {
                citiesSelectorHead.closest('.location-wrapper').classList.remove('noActive');
            } else {
                citiesSelectorHead.closest('.location-wrapper').classList.add('noActive');
            }
        });

        citiesSelectorHead.addEventListener('change', function (e) {
            let citiesSelectorHeadValue = e.target.value;
            citiesCheckboxes.forEach((item) => {
                if (item.value !== citiesSelectorHeadValue) {
                    item.checked = false;
                    updateFiltrationParameters();
                } else {
                    item.checked = true;
                }
            });
        });

        let json = vacancies_data_json || {};
        const autoCompletejs = new autoComplete({
            data: {
                src: async function () {
                    return json;
                },
                key: ["name"],
            },
            sort: function (a, b) {
                if (a.match < b.match) {
                    return -1;
                }
                if (a.match > b.match) {
                    return 1;
                }
                return 0;
            },
            query: {
                /*manipulate: function (query) {
                    return query.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                },*/
            },
            trigger: {
                event: ["input"],
                condition: function (query) {
                    return !!query.replace(/ /g, "").length && query !== "hamburger";
                },
            },
            // placeHolder: "Company name",
            selector: "#jobTitle",
            debounce: 0,
            searchEngine: "strict",
            highlight: true,
            maxResults: 5,
            resultsList: {
                render: true,
                container: function (source) {
                    source.setAttribute("id", "autoComplete_list");
                },
                element: "ul",
                destination: document.querySelector("#jobTitle"),
                position: "afterend",
            },
            resultItem: {
                content: function (data, source) {
                    source.innerHTML = data.match;
                },
                element: "li",
            },
            noResults: function () {
                const result = document.createElement("li");
                result.setAttribute("class", "no_result");
                result.setAttribute("tabindex", "1");
                result.innerHTML = "No Results";
                document.querySelector("#autoComplete_list").appendChild(result);
            },
            onSelection: function (feedback) {
                document.querySelector("#jobTitle").blur();
                const selection = feedback.selection.value.name;
                document.querySelector("#jobTitle").value = selection;
                document.querySelector("#jobTitle").removeAttribute('data-id');
                document.querySelector("#autoComplete_list").innerHTML = '';
                updateFiltrationParameters();
                // console.log(feedback);
            },
        });

    }


};
